import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import PostPaymentFormAnswer from '../../../../../Model/PostPaymentFormAnswer';
import Lead from '../../../../../Model/Lead';
import User from '../../../../../../Model/User';
import AddToNotesMenu from '../../../../../../components/AddToNotesMenu';
import { getFormAnswersFromData } from '../../../../../utils/formAnswers';

import {
  QuestionContainer,
  Question,
  Answer,
} from './styles';

const FormResponseContainer = ({
  formDoc,
  clientUserDoc,
}) => {
  const responsesData = useMemo(() => getFormAnswersFromData(formDoc), [formDoc]);
  return (
    <AddToNotesMenu clientUserDoc={clientUserDoc}>
      {!!responsesData && responsesData.map(({ question, answer }) => !!answer
          && (
            <QuestionContainer key={`${question}-${answer}`}>
              <Question>{question}</Question>
              <Answer>{answer}</Answer>
            </QuestionContainer>
          ))}
    </AddToNotesMenu>
  );
};

FormResponseContainer.propTypes = {
  formDoc: PropTypes.oneOfType([
    PropTypes.instanceOf(PostPaymentFormAnswer),
    PropTypes.instanceOf(Lead),
  ]).isRequired,
  clientUserDoc: PropTypes.instanceOf(User),
};

FormResponseContainer.defaultProps = {
  clientUserDoc: null,
};

export default FormResponseContainer;
